class OsanoTrigger extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleMouseEnter = this.handleTriggerClick.bind(this)

    this.listeners.add(this, 'click', this.handleTriggerClick)
  }

  handleTriggerClick () {
    if (window.Osano) {
      window.Osano.cm.showDrawer()
    }
  }
}

if (!customElements.get('osano-trigger')) {
  customElements.define('osano-trigger', OsanoTrigger, { extends: 'button' })
}
